var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('span',{class:_vm.cssClass,attrs:{"title":_vm.value}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }